import { ClipboardText, Teacher } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - QUESTION BANK LIST ||============================== //

export const PerformanceEvaluation: NavItemType = {
  id: 'group-performance',
  title: 'Performance Evaluation',
  type: 'group',
  children: [
    {
      id: 'performance-evaluation',
      title: 'Performance Evaluation',
      type: 'item',
      url: '/performance-evaluation',
      icon: Teacher,
      breadcrumbs: false
    }
  ]
};

export default PerformanceEvaluation;
